import IconChevronDown from '@apollo/icons/default/IconChevronDown.svg';
import type { SelectProps as ChakraSelectProps } from '@chakra-ui/react';
import { Select as ChakraSelect } from '@chakra-ui/react';
import React from 'react';

import type { OmitChakraProps } from '../../utils/typeUtils';
import { withChakraAs } from '../../utils/withChakraAs';

export type SelectProps = OmitChakraProps<
  ChakraSelectProps,
  'styleConfig' | 'orientation' | 'colorScheme'
>;

/**
 * The Select component is meant to be used nested within a `form` tag.
 * Use the `Menu` component for all other uses cases.
 */
export const Select = withChakraAs<SelectProps, 'select'>(
  ({ icon = <IconChevronDown />, ...props }) => (
    <ChakraSelect {...props} icon={icon} />
  ),
);
